import { h, Fragment } from 'preact';
import Image from 'utils/image';
import { useProduct } from './product-context';
import './value-prop.css';

const ValueProp = () => {
  const { data } = useProduct();

  const checkContent = data.valueProps.some((value) => value.text !== '' && value.title !== '');

  if (data.valueProps.length === 0 || !checkContent) return null;

  return (
    <>
      <div class="value-prop-container">
        <div class="value-prop-grid">
          {data.valueProps.map((value, index) => (
            <>
              {(value.text !== '' || value.title !== '') && (
                <div key={index} class="value-prop-item">
                  <div class="value-prop-icon">
                    <Image {...value?.imageObject} additionalClasses="w-[40px]" />
                  </div>
                  <div class="value-prop-text">
                    <h3>{value?.title}</h3>
                    <p>{value?.text}</p>
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default ValueProp;
